import { Tag } from 'antd';
import { ConfirmTypeEn } from 'src/constants/confirmTypeEn.enum';
import { FlatItem } from 'src/types/elements.type';
import { TicketStatus } from 'src/types/helpdesk/ticket.type';
import { IOvertimeTicket } from 'src/types/hr_ticket/overtimeTicket.type';
interface Props {
  ticketStatus: FlatItem | undefined;
  type?: 'handoverTicket' | 'hrConfirm' | 'overtimeTicket';
  hrConfirmedType?: ConfirmTypeEn;
  erpKey?: number;
  overtimeTicket?: IOvertimeTicket;
}

const TicketStatusTag = ({ ticketStatus }: Props) => {
  let colorCode: string = 'var(--color-new)';

  if (ticketStatus?.id === TicketStatus.ApprovedRequest) {
    colorCode = 'var(--color-approved-request)';
  } else if (ticketStatus?.id === TicketStatus.AcceptReceiveRequest) {
    colorCode = 'var(--color-accept-request)';
  } else if (ticketStatus?.id === TicketStatus.Processing) {
    colorCode = 'var(--color-processing)';
  } else if (ticketStatus?.id === TicketStatus.HandleCompleted) {
    colorCode = 'var(--color-handle-completed)';
  } else if (ticketStatus?.id === TicketStatus.Finished) {
    colorCode = 'var(--color-finished)';
  } else if (ticketStatus?.id === TicketStatus.Reject) {
    colorCode = 'var(--color-rejected)';
  } else if (ticketStatus?.id === TicketStatus.Canceled) {
    colorCode = 'var(--color-canceled)';
  }
  return <Tag color={colorCode}>{ticketStatus?.name}</Tag>;
};

const HRTicketStatusTag = ({
  ticketStatus,
  hrConfirmedType,
  isSupervisorConfirmed,
  isConfirm,
  confirmedType,
  erpKey
}: {
  ticketStatus: FlatItem | undefined;
  hrConfirmedType?: ConfirmTypeEn;
  isSupervisorConfirmed?: ConfirmTypeEn;
  isConfirm?: ConfirmTypeEn;
  confirmedType?: ConfirmTypeEn;
  erpKey?: number;
}) => {
  let colorCode: string = '';

  switch (ticketStatus?.id) {
    case TicketStatus.New:
      colorCode = 'var(--color-new)';
      break;
    case TicketStatus.Canceled:
      colorCode = 'var(--color-canceled)';
      break;
    case TicketStatus.ApprovedRequest:
      if (hrConfirmedType !== undefined) {
        if (!!erpKey) {
          return <Tag color={'var(--color-finished)'}>Đã đồng bộ</Tag>;
        }

        // Nhân sự xác nhận trường hợp có Yêu cầu cung ứng xác nhận
        if (!!isConfirm && hrConfirmedType !== undefined) {
          if (hrConfirmedType === ConfirmTypeEn.WaitingConfirm) {
            return <Tag color='var(--color-new)'>HR xác nhận</Tag>;
          } else if (hrConfirmedType === ConfirmTypeEn.Confirmed) {
            return <Tag color={'var(--color-approved-request)'}>Hoàn thành</Tag>;
          }
        }

        // Yêu cầu cung ứng xác nhận trường hợp có Giám xác xác nhận
        else if (!!isSupervisorConfirmed && isConfirm !== undefined) {
          if (isConfirm === ConfirmTypeEn.WaitingConfirm) {
            return <Tag color={'var(--color-new)'}>Người Y/C xác nhận</Tag>;
          } else if (isConfirm === ConfirmTypeEn.Confirmed) {
            return <Tag color={'var(--color-approved-request)'}>Người Y/C đã xác nhận</Tag>;
          }
        }

        // Giám sát
        else if (isSupervisorConfirmed === ConfirmTypeEn.WaitingConfirm) {
          return <Tag color={'var(--color-new)'}>Giám sát xác nhận</Tag>;
        } else if (isSupervisorConfirmed === ConfirmTypeEn.Confirmed) {
          return <Tag color={'var(--color-approved-request)'}>Giám sát đã xác nhận</Tag>;
        }

        // Yêu cầu cung ứng
        else if (isConfirm === ConfirmTypeEn.WaitingConfirm) {
          return <Tag color={'var(--color-new)'}>Người Y/C xác nhận</Tag>;
        } else if (isConfirm === ConfirmTypeEn.Confirmed) {
          return <Tag color={'var(--color-approved-request)'}>Người Y/C đã xác nhận</Tag>;
        }

        // Nhân sự xác nhận
        else if (hrConfirmedType === ConfirmTypeEn.WaitingConfirm) {
          return <Tag color='var(--color-new)'>HR xác nhận</Tag>;
        } else if (hrConfirmedType === ConfirmTypeEn.Confirmed) {
          return <Tag color={'var(--color-approved-request)'}>Hoàn thành</Tag>;
        }
        colorCode = 'var(--color-approved-request)';
      }
      // Xác nhận vận chuyển
      else if (confirmedType !== undefined) {
        if (confirmedType === ConfirmTypeEn.WaitingConfirm) {
          return <Tag color={'var(--color-new)'}>Chờ xác nhận</Tag>;
        } else if (confirmedType === ConfirmTypeEn.Confirmed) {
          return <Tag color={'var(--color-approved-request)'}>Đã xác nhận</Tag>;
        }
      } else {
        return <Tag color={'var(--color-approved-request)'}>Hoàn thành</Tag>;
      }
      break;
    case TicketStatus.Reject:
      if (hrConfirmedType === ConfirmTypeEn.Reject) {
        return <Tag color='var(--color-rejected)'>HR từ chối</Tag>;
      } else if (isConfirm === ConfirmTypeEn.Reject) {
        return <Tag color={'var(--color-rejected)'}>Người Y/C từ chối</Tag>;
      } else if (isSupervisorConfirmed === ConfirmTypeEn.Reject) {
        return <Tag color={'var(--color-rejected)'}>Giám sát từ chối</Tag>;
      } else if (confirmedType === ConfirmTypeEn.Reject) {
        return <Tag color={'var(--color-rejected)'}>BP vận chuyển từ chối</Tag>;
      }
      colorCode = 'var(--color-rejected)';
      break;
    default:
      break;
  }

  return <Tag color={colorCode}>{ticketStatus?.name}</Tag>;
};

export { HRTicketStatusTag, TicketStatusTag };
